import React from 'react';

import { SpecialEventStatusVariant as SpecialEventStatus } from 'appConstants';
import type { SpecialEventStatusVariant } from 'appTypes';
import StlChip, { IStlChip } from 'features/common/StlChip';

const chipVariants: Record<SpecialEventStatusVariant, IStlChip> = {
  [SpecialEventStatus.loading]: {
    label: 'Loading',
    color: { bg: 'rgba(78, 141, 194, 0.20)' },
  },
  [SpecialEventStatus.requested]: {
    label: 'Requested',
    color: { bg: 'rgba(244, 199, 95, 0.20)' },
  },
  [SpecialEventStatus.available]: {
    label: 'Available',
    color: { bg: 'rgba(69, 139, 75, 0.20)' },
  },
};

interface StatusChipVariantProps {
  variant: SpecialEventStatusVariant;
}

export function StatusChip({ variant }: StatusChipVariantProps) {
  if (!variant) return null;
  const { label, color } = chipVariants[variant];

  return <StlChip label={label} color={color} />;
}
